<div class="field pt-4 ep-static-label">
  <ng-content></ng-content>
  <label>
    {{ label }}
    @if (control?.touched) {
      {{ control.errors | readableErrors }}
    }
  </label>
</div>
